import "./DaForgotPassword.css";

import { useState } from "react";
import DaPageWrapper from "../DaPageWrapper/DaPageWrapper";
import { Button } from "@mui/material";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";
import { translateStatic } from "../../hooks/useT/useT";

const DaForgotPassword = () => {
  const [email, setEmail] = useState("");

  const handleChange = (e) => {
    setEmail(e.target.value);
  };
  const isButtonDisabled = !email;

  return (
    <DaPageWrapper
      wrapperClass={"da-forgot-card da-page-wrapper"}
      iconType="mail"
      title={<Translate tKey={T_KEYS.DA.FORGOT.TITLE} />}
      subtitle={<Translate tKey={T_KEYS.DA.FORGOT.SUBTITLE} />}
    >
      <form className="da-forgot-form" autoComplete="off" noValidate onSubmit={(e) => e.preventDefault()}>
        <label htmlFor="da-forgot-email" className="da-forgot-label">
          <Translate tKey={T_KEYS.DA.FORGOT.LABEL.EMAIL} />
        </label>

        <input
          id="da-forgot-email"
          className="da-forgot-input"
          type="email"
          placeholder={translateStatic(T_KEYS.DA.FORGOT.PLACEHOLDER.EMAIL)}
          value={email}
          onChange={handleChange}
          autoFocus
        />

        <Button
          className="da-button da-forgot-btn"
          type="submit"
          disabled={isButtonDisabled}
          variant="contained"
          disableElevation
        >
          {translateStatic(T_KEYS.DA.FORGOT.BUTTON.CONTINUE)}
        </Button>

        <div className="da-forgot-privacy">
          {translateStatic(T_KEYS.DA.FORGOT.PRIVACY.PREFIX)}{" "}
          <span className="da-forgot-link">
            <Translate tKey={T_KEYS.DA.FORGOT.PRIVACY.LINK} />
          </span>
        </div>
      </form>
    </DaPageWrapper>
  );
};

export { DaForgotPassword };
